<template>
    <v-card-text class="pa-6">
        <div class="text-right pb-3">
            <v-btn
                @click="$emit('close', false)"
                icon
                color="primary"
                style="height: 20px; width: 20px;"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </div>

        <v-sheet
            tile
            color="#F8F8F8"
            class="pa-4 text-center"
        >
            <h4
                class="title font-weight-bold mb-4"
                style="color: #989898"
            >
                Some examples of apps powered by Plaid
            </h4>
            <v-img
                src="/images/plaid-apps.png"
                class="mx-auto my-8"
                alt="plaid apps picture"
            />

            <div class="d-flex">
                <v-btn
                    class="text-none px-6 rounded-lg primary--text"
                    text
                    color="#f4f4f4"
                    large
                    @click="$emit('cancel')"
                >
                    Back
                </v-btn>
                <v-spacer />
                <v-btn
                    class="text-capitalize px-6 rounded-lg"
                    color="primary"
                    dark
                    depressed
                    large
                    @click.native="$emit('proceed')"
                >
                    Add Bank Account
                </v-btn>
            </div>
        </v-sheet>
    </v-card-text>
</template>

<script>
export default {

}
</script>

<style>

</style>